module.exports = __webpack_public_path__ + "img/home-praise-avator-01.ee29862b.png";